import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import React from "react";
import { makeStyles } from "tss-react/mui";
import * as helpers from "../../helpers";
import Link from "../../link/contrast";
var brandName = "Factbird";
var useStyles = makeStyles()(function(theme) {
    var _obj;
    return {
        wrapLinks: _define_property({
            whiteSpace: "normal"
        }, theme.breakpoints.down("md"), {
            textAlign: "center"
        }),
        bar: (_obj = {
            backgroundColor: theme.palette.background.default,
            color: theme.palette.primary.contrastText,
            backgroundImage: "none",
            position: "relative",
            width: "100%",
            borderRadius: 0,
            whiteSpace: "nowrap"
        }, _define_property(_obj, theme.breakpoints.down("md"), {
            padding: "1em"
        }), _define_property(_obj, "boxShadow", "none"), _define_property(_obj, "zIndex", theme.zIndex.drawer + 1), _define_property(_obj, "@media print", {
            display: "none"
        }), _obj),
        contentJustification: _define_property({
            justifyContent: "space-between"
        }, theme.breakpoints.down("md"), {
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
        }),
        striped: {
            backgroundImage: "repeating-linear-gradient(-45deg, ".concat(theme.palette.background.default, ", ").concat(theme.palette.background.default, " 10px, rgba(255, 255, 255, 0.075) 10px, rgba(255, 255, 255, 0.075) 20px)")
        },
        version: _define_property({
            color: theme.palette.grey.A400
        }, theme.breakpoints.down("md"), {
            display: "block",
            textAlign: "center"
        })
    };
});
export var Footer = function(param) {
    var _links = param.links, links = _links === void 0 ? [] : _links, buildInfo = param.buildInfo;
    var ref = useStyles(), classes = ref.classes, cx = ref.cx;
    var year = new Date().getFullYear();
    var ref1 = buildInfo || {}, commit = ref1.commit, version = ref1.version;
    var isStaging = !!(version && !/^v\d+\.\d+\.\d+$/.test(version));
    return /*#__PURE__*/ _jsx(Paper, {
        component: "footer",
        elevation: 4,
        className: cx(classes.bar, _define_property({}, classes.striped, isStaging)),
        children: /*#__PURE__*/ _jsx(Toolbar, {
            children: /*#__PURE__*/ _jsxs(Grid, {
                container: true,
                spacing: 0,
                className: classes.contentJustification,
                children: [
                    /*#__PURE__*/ _jsx(Grid, {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: /*#__PURE__*/ _jsxs(Typography, {
                            color: "inherit",
                            variant: "subtitle1",
                            children: [
                                "\xa9 ".concat(year, " ").concat(brandName, ". All rights reserved. "),
                                commit && version ? /*#__PURE__*/ _jsx(Tooltip, {
                                    placement: "top",
                                    title: "Build ".concat(commit),
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: cx(classes.version),
                                        children: "Version ".concat(version)
                                    })
                                }) : null
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Grid, {
                        item: true,
                        xs: 12,
                        md: 6,
                        className: "hideInPercy",
                        children: /*#__PURE__*/ _jsx(Typography, {
                            className: classes.wrapLinks,
                            align: "right",
                            color: "inherit",
                            variant: "subtitle1",
                            children: links.map(function(param) {
                                var href = param.href, label = param.label;
                                return /*#__PURE__*/ _jsx(Link, {
                                    href: href,
                                    children: label
                                }, href);
                            }).reduce(helpers.joinWith(" | "), [])
                        })
                    })
                ]
            })
        })
    });
};
